import {FormControl} from '@angular/forms';

const exceptions = []

export function email(c: FormControl) {
    const emailReg = new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

    if (exceptions.includes(c.value)) return null

    return emailReg.test(c.value) ? null : {
        message: 'lta-errors.email'
    };
}
